import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";

export default function ProductDetail({ forWhom, strengths, orientation, ctaLabel }) {
  return (
    <section className="relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="overline mb-4">Für wen</div>
          <h3 className="font-display text-2xl uppercase mb-6">Geeignete Profile</h3>
          <ul className="space-y-3 text-[#AEB7B7] text-sm">
            {forWhom.map((x, i) => (
              <li key={i} className="flex items-start gap-3 border-b border-[rgba(255,255,255,0.08)] pb-3">
                <Check size={16} strokeWidth={1.5} className="text-[#18E096] mt-0.5 shrink-0" />
                <span>{x}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-4">
          <div className="overline mb-4">Was es stark macht</div>
          <h3 className="font-display text-2xl uppercase mb-6">Systemvorteile</h3>
          <ul className="space-y-3 text-[#AEB7B7] text-sm">
            {strengths.map((x, i) => (
              <li key={i} className="flex items-start gap-3 border-b border-[rgba(255,255,255,0.08)] pb-3">
                <span className="text-[#18E096] text-xs mt-1 font-mono">{String(i + 1).padStart(2, "0")}</span>
                <span>{x}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-4">
          <div className="overline mb-4">Orientierung</div>
          <h3 className="font-display text-2xl uppercase mb-6">Standortrahmen</h3>
          <ul className="space-y-4 text-white text-sm">
            {orientation.map((x, i) => (
              <li key={i} className="surface p-5">
                <span className="text-[#AEB7B7] text-xs uppercase tracking-[0.18em] block mb-2">
                  Parameter {String(i + 1).padStart(2, "0")}
                </span>
                <span className="text-white">{x}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-[rgba(255,255,255,0.08)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="text-[#AEB7B7] max-w-xl">
            Die finale Eignung entsteht aus der Kombination von Standort, Zielgruppe, Betrieb
            und Customer Journey – nicht aus Quadratmetern allein.
          </p>
          <Link to="/standort-pruefen" className="btn-primary" data-testid="product-bottom-cta">
            {ctaLabel} <ArrowUpRight size={16} strokeWidth={1.5} />
          </Link>
        </div>
      </div>
    </section>
  );
}
